import { CommonModule } from '@angular/common'
import { HTTP_INTERCEPTORS } from '@angular/common/http'
import { APP_INITIALIZER, NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { EffectsModule } from '@ngrx/effects'
import { Store, StoreModule } from '@ngrx/store'
import { CartPageLayoutHandler } from '@spartacus/cart/base/components'
import { CartBaseCoreModule } from '@spartacus/cart/base/core'
import { OccCartAdapter } from '@spartacus/cart/base/occ'
import { ActiveCartFacade, CartBaseRootModule, MultiCartFacade } from '@spartacus/cart/base/root'
import {
  ConfigurationService,
  I18nModule,
  provideConfig,
  UrlModule,
  WindowRef
} from '@spartacus/core'
import {
  DIALOG_TYPE,
  FormErrorsModule,
  GlobalMessageComponentModule,
  IconModule,
  ItemCounterModule,
  KeyboardFocusModule,
  LayoutConfig,
  MediaModule,
  OutletModule
} from '@spartacus/storefront'

import { EbRequestedShippingDateAdapter } from '../checkout/services/connectors/eb-requested-shipping-date.adapter'
import { EbFormModule } from '../form/eb-form.module'
import { EbMediaService } from '../media/eb-media.service'

import { EbAddToCartComponent } from './components/add-to-cart/eb-add-to-cart.component'
import { EbAddedToCartDialogComponent } from './components/added-to-cart-dialog/eb-added-to-cart-dialog.component'
import { EbCartItemComponent } from './components/cart-item/eb-cart-item.component'
import { EbCartItemHeaderComponent } from './components/cart-item-header/eb-cart-item-header.component'
import { EbCartItemListComponent } from './components/cart-item-list/eb-cart-item-list.component'

import { EbProductSalesTextComponent } from './components/product-sales-text/eb-product-sales-text.component'
import { EbPurchaseProductComponent } from './components/purchase-product/eb-purchase-product.component'
import { EbCartPageLayoutHandler } from './eb-cart-page-layout-handler'
import { EbCartInterceptor } from './interceptor/eb-cart.interceptor'
import { STORE_FEATURE_EB_MULTI_CART } from './interface/eb-multi-cart-state.interface'
import { EbCartAdapter } from './services/connectors/eb-cart.adapter'
import { EbActiveCartService } from './services/eb-active-cart.service'
import { EbMultiCartService } from './services/eb-multi-cart.service'
import { EbCartEntryEffects } from './store/effects/eb-cart-entry.effect'
import { EbCartEffects } from './store/effects/eb-cart.effect'
import { ebCartModificationsReducer } from './store/reducers/eb-multi-cart.reducer'
export const defaultCartDialogModalLayoutConfig: LayoutConfig = {
  launch: {
    ADDED_TO_CART: {
      inlineRoot: true,
      component: EbAddedToCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
}

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    ItemCounterModule,
    UrlModule,
    CartBaseRootModule,
    CartBaseCoreModule,
    MediaModule,
    OutletModule,
    NgbTooltipModule,
    IconModule,
    StoreModule.forFeature(STORE_FEATURE_EB_MULTI_CART, ebCartModificationsReducer),
    EffectsModule.forFeature([EbCartEffects, EbCartEntryEffects]),
    GlobalMessageComponentModule,
    FormErrorsModule,
    EbFormModule,
    RouterModule,
    KeyboardFocusModule,
    EbAddToCartComponent,
    EbAddedToCartDialogComponent,
    EbCartItemComponent,
    EbCartItemHeaderComponent,
    EbCartItemListComponent,
    EbPurchaseProductComponent,
    EbProductSalesTextComponent
  ],
  providers: [
    EbActiveCartService,
    EbMultiCartService,
    EbRequestedShippingDateAdapter,
    provideConfig(defaultCartDialogModalLayoutConfig),
    {
      provide: OccCartAdapter,
      useClass: EbCartAdapter
    },
    {
      provide: MultiCartFacade,
      useExisting: EbMultiCartService
    },
    {
      provide: ActiveCartFacade,
      useExisting: EbActiveCartService
    },
    {
      provide: CartPageLayoutHandler,
      useClass: EbCartPageLayoutHandler
    },
    {
      provide: APP_INITIALIZER,
      useFactory: EbMultiCartService.keepActiveCartIdInSync,
      multi: true,
      deps: [Store, ConfigurationService, WindowRef]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EbCartInterceptor,
      multi: true
    },
    {
      provide: EbMediaService,
      useClass: EbMediaService
    }
  ],
  exports: [
    EbAddToCartComponent,
    EbAddedToCartDialogComponent,
    EbCartItemComponent,
    EbCartItemHeaderComponent,
    EbCartItemListComponent,
    EbPurchaseProductComponent,
    EbProductSalesTextComponent
  ]
})
export class EbCartModule {}
